<template>
    <div>
        <div class="clause-title">
            条款须知
        </div>
        <table class="basic" cellpadding="0" cellspacing="0">
            <tr>
                <td>
                   投保须知
                </td>
                <td>
                    <div class="check" @click="openNotice(0)">
                        查看详情
                    </div>
                </td>
            </tr>
            <tr>
                <td>保险条款</td>
                <td>
                    <div class="check" @click="openNotice(1)">
                        查看详情
                    </div>
                </td>
            </tr>
            <tr>
                <td>客户告知书</td>
                <td>
                    <div class="check" @click="openNotice(3)">
                        查看详情
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "Clause",
        methods:{
            openNotice(type){
                if (type === 0) {
                    this.$router.push({path: '/home/InsNotice'})
                }else if ((type === 1)) {
                    this.$router.push({path: '/home/InsClause'})
                }else if ((type === 3)) {
                    this.$router.push({path: '/home/CustomerPage'})
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .base-table{
        width: 100%;
        background: #ffffff;
        tr{
            height: 13.33vw;
            line-height: 13.33vw;
            td{
                border-bottom: .27vw solid #f5f5f9;
            }
            td:nth-child(1){
                padding-left: 5.33vw;
                text-align: left;
                color: #333333;
            }
            td:nth-child(2){
                padding-right: 5.33vw;
                text-align: right;
                color: #666666;
            }
        }
    }
    .clause-title{
        height: 12vw;
        padding-left: 10.67vw;
        margin-top: 2.67vw;
        line-height: 12vw;
        text-align: left;
        font-size: 4.27vw;
        font-weight: bold;
        background: url(../assets/clause.png) no-repeat 5.33vw center #ffffff;
        background-size: 4vw;
    }
    .basic{
        .check{
            max-width: 72.8vw;
            padding-right: 4.53vw;
            color: #3385ff;
            background: url(../assets/right.png) no-repeat right center;
            background-size: 1.33vw;
        }
        @extend .base-table
    }
</style>
